import { GetAxiosInstance } from '../../baseService';
import { ConvertServiceLocationToEnum } from '../../serviceLocationsAxios';

export interface AutoCompleteRowType {
  endPoint?: string;
  serviceLocation?: string;
  filter?: string;
  showDeleted?: boolean;
  sort?: string;
  pageNumber?: number;
  pageSize?: number;
  includeMetadata?: boolean;
  ignoreOwner?: boolean;
}

// get the master data item we are retrieving from the DB
export const getAutoCompleteRows = async (params: AutoCompleteRowType, tenantId?: string, partnerId?: string) => {
  return GetAxiosInstance(undefined, tenantId, partnerId).get(ConvertServiceLocationToEnum(params.serviceLocation) + '/' + params.endPoint, {
    params
  });
};
